export default __webpack_public_path__ + "static/media/avatar.faa14dc4.png";